const phoneNumberMask = (phoneNumber = '')=> {
  let subNum = `${phoneNumber.toString().substring(0,3)}-${phoneNumber.toString().substring(3,6)}`
  subNum = subNum + "-XXXX"
  return subNum
}

export default phoneNumberMask;